export const ENV = {
  MODE: import.meta.env.MODE || 'development',
  DEV: import.meta.env.DEV,
  PROD: import.meta.env.PROD,

  API_URL: import.meta.env.VITE_API_URL || 'http://localhost:3000/api',
  LOGIN_ROUTE: import.meta.env.VITE_LOGIN_ROUTE || '/login',
  CDN_BASE_URL: import.meta.env.VITE_CDN_BASE_URL || 'https://assets.cdn.plurall.net/static/assets/icons',
  ANGULAR_PLATFORM_URL: import.meta.env.VITE_ANGULAR_PLATFORM_URL || 'https://homolog-portal.redacaonota1000.com.br',
  LEGACY_PLATFORM_URL: import.meta.env.VITE_LEGACY_PLATFORM_URL || import.meta.env.VITE_ANGULAR_PLATFORM_URL || '',
} as const;

export const isDevelopment = (): boolean => ENV.DEV;
export const isProduction = (): boolean => ENV.PROD;
export const getMode = (): string => ENV.MODE;
